// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsIndicatorsEditForm_heading__OVzcD","form":"ReportingDetailsIndicatorsEditForm_form__SPvBq"};